module.exports = __webpack_public_path__ + "static/media/icon-like-to-learn.3676c5a7.svg";